import { render, staticRenderFns } from "./UnsyncedMessageDetail.vue?vue&type=template&id=437ec620&scoped=true"
import script from "./UnsyncedMessageDetail.vue?vue&type=script&lang=js"
export * from "./UnsyncedMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./UnsyncedMessageDetail.vue?vue&type=style&index=0&id=437ec620&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ec620",
  null
  
)

export default component.exports